import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class StickyList extends UcoastEl {
    static htmlSelector = 'sticky-list'

    button: HTMLLinkElement
    wrapper: HTMLElement

    constructor() {
        super()
        this.button = q.rs('.section-tabs__list-wrapper', this)
        this.wrapper = q.rs('.sticky-list-wrapper', document)
    }

    override connectedCallback(): void {
        const handleScroll = () => {
            if(this.getBoundingClientRect().top <= 20) {
                if(!this.wrapper.querySelector('.section-tabs__list-wrapper')) this.wrapper.appendChild(this.button)
            } else {
                if(!this.querySelector('.section-tabs__list-wrapper')) this.appendChild(this.button)
            }
        }

        const resize = () => {
            const tabsContent = q.rs('.section-tabs__list-wrapper', document)
            this.style.height = `${tabsContent.offsetHeight}px`
        }
        window.addEventListener('scroll', handleScroll, { passive: true })
        window.addEventListener('resize', handleScroll, { passive: true })
        handleScroll()
        resize()
    }
}
